
(function(){
 // utility rotation
 var u=document.querySelectorAll('.util__msg');if(u.length>1){var i=0;setInterval(function(){u[i].classList.remove('is-on');i=(i+1)%u.length;u[i].classList.add('is-on')},4000)}
 // tabs
 document.querySelectorAll('[data-tabs]').forEach(function(root){
  var btns=root.querySelectorAll('[data-tab]'),panels=root.querySelectorAll('[data-panel]');
  btns.forEach(function(b){b.addEventListener('click',function(){var k=b.getAttribute('data-tab');btns.forEach(function(x){x.classList.toggle('is-on',x===b)});panels.forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-panel')===k)})})});
 });
 // carousels
 document.querySelectorAll('[data-scroller]').forEach(function(root){
  var t=root.querySelector('[data-track]');if(!t)return;
  root.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){t.scrollBy({left:parseInt(b.getAttribute('data-dir'))*t.clientWidth*.7,behavior:'smooth'})})});
 });
 // mobile menu
 var m=document.querySelector('.menu-btn'),h=document.querySelector('.hdr');if(m&&h)m.addEventListener('click',function(){h.classList.toggle('is-open')});
})();
